export default "__VITE_ASSET__CTKRtbJd__"